// extracted by mini-css-extract-plugin
export default {"cardsList":"SheetCardsList_cardsList__IT+fj","cardsListTitle":"SheetCardsList_cardsListTitle__+Ma61"};